import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { AnonymousUserModel } from '../../core/models/anonymous-user-login/anonymous-user.model';
import { LoggedInUserModel } from '../../core/models/logged-in-user.model';
import { SecurityService } from '../../core/services/security.service';
import { GlobalEventsManagerService } from '../../core/services/global-events-manager.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CONFIG } from '../../core/config';

@Component({
    selector: 'app-anonymous-user-login',
    templateUrl: './anonymous-user-login.component.html'
})
export class AnonymousUserLoginComponent implements OnInit {
    public anonymousUser: AnonymousUserModel;
    public loggedInUser: LoggedInUserModel;

    constructor(private _loginService: LoginService,
        private _securityService: SecurityService,
        private _eventsManagerService: GlobalEventsManagerService,
        private _router: Router, private _route: ActivatedRoute) {
        this.anonymousUser = new AnonymousUserModel();
        this.loggedInUser = new LoggedInUserModel();
    }

    ngOnInit() {
        this.initAnonymousUser();
    }

    initAnonymousUser() {
        this.anonymousUser.applicationTypeID = CONFIG.applicationType;
    }

    onSubmit() {
        this._loginService.anonymousUserLogin(this.anonymousUser).subscribe(result => {
            this.loggedInUser = result;
            this._securityService.saveToLocalStorage(this.loggedInUser);
                this._eventsManagerService.loggedIn(true);

            let params = this._route.snapshot.queryParams;

            if (params['redirectURL']) {
                this._router.navigate([params['redirectURL']]);
            } else {
                this._router.navigate(['/home']);
            }
        });
    }

}
